import '@/app/app.css';
import './account.css';

import '@/app/app';
import '@/layouts/main/main';
import { AccountOrder } from '@/features/account/account-orders/account-order/account-order';
import { CodeForm } from '@/features/authorization/code-form/code-form';
import { AccountSendCode } from '@/features/account/account-send-code/account-send-code';
import { AccountPersonal } from '@/features/account/account-personal/account-personal';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-account-order').forEach((element) => new AccountOrder(element));
	window.app.accountCode = new CodeForm(document.querySelector('.account-code__form'));
	new AccountSendCode(document.querySelector('.js-account-send-code'));
	if (import.meta.env.DEV) {
		window.app.classInstance.get(document.querySelector('.js-account-send-code'))?.accountSendCode?.addCallbacks({
			onCodeSent: () => fetch('../data/forms/login-tel.json'),
		});
	}
	new AccountPersonal(document.querySelector('.js-account-personal'));
});
